import { twJoin } from "tailwind-merge";

type SkeletonPlaceholderProps = {
  width?:
    | `w-${number}`
    | `w-${number}/${number}`
    | "w-full"
    | `w-[${number}px]`;
  height?:
    | `h-${number}`
    | `h-${number}/${number}`
    | "h-full"
    | `h-[${number}px]`;
  rounded?: "rounded-full" | "rounded-lg";
  shrink0?: boolean;
  dataLoc?: string;
  display?: "block" | "inline" | "inline-block";
};

export const SkeletonPlaceholder: React.FC<SkeletonPlaceholderProps> = ({
  width = "w-full",
  height,
  rounded,
  shrink0,
  display = "block",
  dataLoc,
}) => (
  <div
    className={twJoin(
      "relative overflow-hidden rounded bg-gray-100",
      width,
      height,
      rounded,
      shrink0 && "shrink-0",
      display,
    )}
    data-loc={dataLoc}
    role="status"
  >
    <div
      className="absolute inset-0 -translate-x-full transform bg-gradient-to-r from-gray-100 via-gray-50 to-gray-100"
      style={{ animation: "shimmer 1s infinite" }}
    ></div>
  </div>
);
